import PatPoints from "../../football/enums/pat-points";
import FirstDownStyles from "../../football/enums/first-down-styles";
import BooleanType from "../../football/enums/boolean-type";
import ClockType from "../../football/enums/clock-type";
import FieldLength from "../../football/enums/field-length";
import FieldAreaType from "../../football/enums/field-area-type";
import TeamLoss from "../../football/enums/team-loss";
import ParticipationStyle from "../../football/enums/participation-style";

const customFormData = {
    general: {
        title: "Game information",
        order: 1,
        downs: {
            order: 7
        },
        endZoneLength: {
            title: "End Zone Length (yds)",
            order: 6
        },
        fieldLength: {
            title: "Field Length (yds)",
            options: Object.values(FieldLength).filter(
                ({ code }) =>
                    code % 4 === 0 || code === FieldLength.OptionTwo.code
            ),
            order: 3
        },
        fieldWidth: {
            title: "Field Width (yds)",
            order: 4
        },
        firstDownFlagStyle: {
            title: "First Down Setting",
            order: 9,
            options: Object.values(FirstDownStyles),
            row: 3
        },
        firstDownYards: {
            disabled: true
        },
        // Internal marker-editor flag (set by the UI when the crew edits the
        // first-down spots) — never rendered as a form field.
        customFirstDownYardSet: {
            disabled: true
        },
        firstDownYardSet: {
            title: "First Down Spots",
            component: "fieldMarkers",
            markerKind: "point",
            order: 10,
            row: 3
        },
        fieldAreaSet: {
            title: "Field Areas",
            component: "fieldMarkers",
            markerKind: "region",
            // NoRunZone hidden from the picker for now (no rule behavior yet);
            // existing/preset noRunZone areas still render in the editor.
            areaTypes: Object.values(FieldAreaType).filter(
                (t) => t.code !== FieldAreaType.NoRunZone.code
            ),
            order: 11,
            row: 3
        },
        minutesByPeriod: {
            title: "Period Length (min)",
            order: 2
        },
        periodsInRegulation: {
            title: "Number of Periods",
            order: 1
        },
        redZoneLength: {
            disabled: true
        },
        zoneLength: {
            title: "Zone Length (yds)",
            order: 5,
            disabled: true
        },
        timeoutsPerHalf: {
            order: 8
        },
        rushType: {
            title: "Rush Type",
            options: Object.values(BooleanType)
        },
        passType: {
            title: "Pass Type",
            options: Object.values(BooleanType)
        },
        // Legacy keys — clock settings live in the clock section now, but
        // configs saved before the move may still carry them in general.
        clockType: {
            disabled: true
        },
        runningClock: {
            disabled: true
        },
        spikeTeamAttOnly: {
            title: "Spike as Team Attempt Only",
            options: Object.values(BooleanType)
        },
        touchdownsCountAsFirstDowns: {
            title: "Touchdowns Count as 1st Downs",
            options: Object.values(BooleanType)
        },
        teamLossOnly: {
            title: "Team Loss Only",
            options: Object.values(TeamLoss),
            multiselect: true
        },
        teamZoneQty: {
            disabled: true
        },
        participationStyle: {
            title: "Participation Style",
            options: Object.values(ParticipationStyle)
        }
    },
    clock: {
        title: "Clock",
        // editableAfterStart: clock settings stay editable while the rest of
        // the form is locked mid-game (the save guard only allows clock-
        // section changes through).
        clockType: {
            title: "Clock Type",
            options: Object.values(ClockType),
            editableAfterStart: true
        },
        // No options: plain booleans render as a Switch in the form.
        runningClock: {
            title: "Running Clock",
            editableAfterStart: true
        }
    },
    spots: {
        title: "Default Yardlines",
        order: 3,
        touchbackYardline: {
            title: "Touchback Yardline"
        },
        overtimeStartingYardline: {
            title: "Overtime Starting Yardline"
        },
        kickoff: {
            disabled: true
        },
        spotsPatScoreOption1: {
            title: "PAT Score (Option 1)",
            row: 2,
            order: 1
        },
        spotsPatScoreOption2: {
            title: "PAT Score (Option 2)",
            row: 2,
            order: 2
        },
        spotsPatScoreOption3: {
            title: "PAT Score (Option 3)",
            row: 2,
            order: 3
        }
    },
    scoring: {
        title: "Scoring Information",
        order: 2,
        touchdown: {
            title: "Touchdown Score",
            row: 1,
            order: 1
        },
        safety: {
            title: "Safety Score",
            row: 1,
            order: 2
        },
        scoringPatScoreOption1: {
            title: PatPoints.OptionOne.name,
            row: 2,
            order: 1
        },
        scoringPatScoreOption2: {
            title: PatPoints.OptionTwo.name,
            row: 2,
            order: 2
        },
        scoringPatScoreOption3: {
            title: PatPoints.OptionThree.name,
            row: 2,
            order: 3
        },
        driveStartingYardline: {
            title: "Drive Starting Yardline"
        },
        safetyYardline: {
            title: "Safety Yardline"
        },
        playSummary: {
            disabled: true
        },
        rougePoints: {
            disabled: true
        },
        fieldGoal: {
            disabled: true
        }
    }
};

export default customFormData;
